// extracted by mini-css-extract-plugin
export default {"root":"mz5SnC5v","svg":"Bv8eTAeQ","layer":"z8bnK4Uo","layerFaded":"tx6_4jm_"};